import { Selector } from '@ngxs/store';
import { AccountingStateModel } from './accounting.models';
import { AccountingState } from './accounting.state';
import {
  AccountingAccount,
  AccountingConnectionStatus,
  AccountingProviderCompany,
  AccountingTaxRates,
  AccountingTrackingCategory,
  TenantAccountOption,
} from '../../_interfaces/accounting.interface';

export class AccountingSelectors {
  @Selector([AccountingState])
  static provider(state: AccountingStateModel): AccountingProviderCompany | undefined {
    return state.provider;
  }

  @Selector([AccountingState])
  static connectionStatus(state: AccountingStateModel): AccountingConnectionStatus | undefined {
    return state.connectionStatus;
  }

  @Selector([AccountingState])
  static providerNewBankAccountsCreated(state: AccountingStateModel): boolean | undefined {
    return state.bank_accounts_created;
  }

  @Selector([AccountingState])
  static tenantDetail(state: AccountingStateModel): TenantAccountOption | undefined {
    return state.tenant;
  }

  @Selector([AccountingState])
  static sourceAccount(state: AccountingStateModel): AccountingAccount | undefined {
    return state.source_account;
  }

  @Selector([AccountingState])
  static syncEnabled(state: AccountingStateModel): boolean | undefined {
    return state.sync_enabled;
  }

  @Selector([AccountingState])
  static trackingCategories(state: AccountingStateModel): AccountingTrackingCategory[] {
    return state.trackingCategories;
  }

  @Selector([AccountingState])
  static trackingCategoriesLastFetched(state: AccountingStateModel): number | null {
    return state.trackingCategoriesLastFetched;
  }

  @Selector([AccountingState])
  static taxRates(state: AccountingStateModel): AccountingTaxRates[] {
    return state.taxRates;
  }

  @Selector([AccountingState])
  static taxRatesLastFetched(state: AccountingStateModel): number | null {
    return state.taxRatesLastFetched;
  }
}
